import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  age: string;
  content: string;
  imageIndex: number;
}
export function TestimonialCard({
  name,
  location,
  age,
  content,
  imageIndex
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-stone-100 flex flex-col h-full" data-id="element-25">
      <div className="flex items-center gap-1 mb-4 text-yellow-400" data-id="element-26">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-27" />)}
      </div>

      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-28">"{content}"</p>

      <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-100" data-id="element-29">
        <div className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center text-stone-500 font-bold text-sm" data-id="element-30">
          {name.charAt(0)}
        </div>
        <div data-id="element-31">
          <p className="font-bold text-gray-900 text-sm" data-id="element-32">
            {name}, {age}
          </p>
          <p className="text-xs text-gray-500" data-id="element-33">{location}</p>
        </div>
      </div>
    </div>;
}